import React from 'react'

import type {UnifiedSignupModalQuery} from '@/graphql-types'
import exhaustiveCheck from '@/utils/exhaustive-check'

import {CroppedImage} from './slices/cropped-image'
import {SocialProof} from './slices/social-proof'

type SliceData =
    UnifiedSignupModalQuery['allPrismicUnifiedSignupModal']['nodes'][number]['data']['body'][number]

type SliceProps = {
    slice: SliceData
}

const Slice = ({slice}: SliceProps) => {
    const typename = slice.__typename

    switch (typename) {
        case 'PrismicUnifiedSignupModalDataBodySocialProof':
            return <SocialProof slice={slice} />
        case 'PrismicUnifiedSignupModalDataBodyCroppedImage':
            return <CroppedImage slice={slice} />
        default:
            exhaustiveCheck(typename)
            throw new Error(`Unknown slice: ${JSON.stringify(slice)}`)
    }
}

type Props = {
    slices: SliceData[]
}

export const SliceZone = ({slices}: Props) => {
    return (
        <>
            {slices.map((slice, i) => {
                if (!slice.__typename) {
                    throw new Error(`Missing __typename in slice: ${JSON.stringify(slice)}`)
                }

                return <Slice key={i} slice={slice} />
            })}
        </>
    )
}
